import type { IconType } from '../../../../theme/themes/ThemeTypes';

export const Settings: IconType = ({ colour, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={43} height={42} fill="none" {...props}>
    <path
      stroke={colour}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M35.064 12.644a3.256 3.256 0 0 0 1.55 4.344c.096.049.205.085.314.134l2.202.786c1.694.605 2.59 2.469 1.985 4.163a3.229 3.229 0 0 1-1.985 1.984l-2.202.787a3.274 3.274 0 0 0-1.985 4.163c.036.109.085.206.133.315l1.005 2.105a3.26 3.26 0 0 1-4.344 4.344l-2.106-1.004a3.256 3.256 0 0 0-4.345 1.549c-.048.097-.084.206-.133.315l-.786 2.202a3.273 3.273 0 0 1-4.163 1.985 3.288 3.288 0 0 1-1.985-1.985l-.786-2.202c-.605-1.695-2.469-2.59-4.163-1.985-.109.036-.206.085-.303.133l-2.105 1.005a3.257 3.257 0 0 1-4.344-1.525 3.287 3.287 0 0 1 0-2.82l1.004-2.105a3.256 3.256 0 0 0-1.549-4.345c-.097-.048-.206-.084-.315-.133l-2.202-.786c-1.694-.605-2.59-2.469-1.985-4.163a3.229 3.229 0 0 1 1.985-1.985l2.202-.786a3.273 3.273 0 0 0 1.985-4.163c-.036-.109-.085-.206-.121-.303l-1.004-2.105a3.257 3.257 0 0 1 1.524-4.345 3.287 3.287 0 0 1 2.82 0l2.105 1.005a3.256 3.256 0 0 0 4.345-1.55c.048-.096.084-.193.12-.302l.787-2.202a3.273 3.273 0 0 1 4.163-1.985 3.288 3.288 0 0 1 1.985 1.985l.786 2.202a3.273 3.273 0 0 0 4.163 1.985c.109-.036.206-.085.315-.133l2.105-1.005a3.26 3.26 0 0 1 4.344 4.344l-1.004 2.106-.012-.024Z"
    />
    <path
      stroke={colour}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M13.452 20.97c0 4.32 3.497 7.83 7.829 7.83a7.82 7.82 0 0 0 7.83-7.83c0-4.332-3.51-7.83-7.83-7.83s-7.83 3.51-7.83 7.83Z"
    />
  </svg>
);
